import { useTranslation } from "react-i18next"

import { AnalyticsKpiTile } from "@/components/brand/analytics/analytics-kpi-tile"
import type { MissionAnalyticsDetailKpis } from "@/types/mission-analytics"

/**
 * OKS-63 — Per-mission deep-dive KPI strip (4 tiles).
 *
 * Mirrors `AnalyticsOverviewKpiStrip` shape but swaps Total missions
 * for Approved submissions (the per-mission KPI bag has no
 * `total_missions`).
 */
export interface AnalyticsDetailKpiStripProps {
  kpis: MissionAnalyticsDetailKpis
}

export function AnalyticsDetailKpiStrip({
  kpis,
}: AnalyticsDetailKpiStripProps) {
  const { t } = useTranslation()

  return (
    <section
      aria-label={t("analytics.kpis.section_aria")}
      data-testid="analytics-detail-kpi-strip"
      className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4"
    >
      <AnalyticsKpiTile
        labelKey="analytics.kpis.total_collabs.label"
        ariaLabelKey="analytics.kpis.total_collabs.aria"
        value={kpis.total_collabs}
        kind="integer"
        testId="analytics-detail-kpi-tile-total_collabs"
      />
      <AnalyticsKpiTile
        labelKey="analytics.kpis.acceptance_rate.label"
        ariaLabelKey="analytics.kpis.acceptance_rate.aria"
        emptyAriaKey="analytics.kpis.acceptance_rate.empty_aria"
        value={kpis.acceptance_rate}
        kind="percent"
        numerator={kpis.acceptance_numerator}
        denominator={kpis.acceptance_denominator}
        tooltipKey="analytics.kpis.acceptance_rate.tooltip"
        testId="analytics-detail-kpi-tile-acceptance_rate"
      />
      <AnalyticsKpiTile
        labelKey="analytics.kpis.completion_rate.label"
        ariaLabelKey="analytics.kpis.completion_rate.aria"
        emptyAriaKey="analytics.kpis.completion_rate.empty_aria"
        value={kpis.completion_rate}
        kind="percent"
        numerator={kpis.completion_numerator}
        denominator={kpis.completion_denominator}
        tooltipKey="analytics.kpis.completion_rate.tooltip"
        testId="analytics-detail-kpi-tile-completion_rate"
      />
      <AnalyticsKpiTile
        labelKey="analytics.kpis.approved_submissions.label"
        ariaLabelKey="analytics.kpis.approved_submissions.aria"
        value={kpis.approved_submissions}
        kind="integer"
        testId="analytics-detail-kpi-tile-approved_submissions"
      />
    </section>
  )
}
